module.exports = __webpack_public_path__ + "static/robotCover-511c0949aeb81e0596ef36cdc0b980a2.png";